import { ReebeloStoreT } from '@lambda/reebelo';
import settings from '@/settings';

import { usBlog } from './US';
import { ukBlog } from './UK';
import { auBlog } from './AU';
import { caBlog } from './CA';
import { sgBlog } from './SG';
import { nzBlogs } from './NZ';

import { BlogArticle } from './types';

type BlogConfig = {
  title: string;
  articles: BlogArticle[];
};

const BLOGS_BY_STORE: Partial<Record<ReebeloStoreT, BlogConfig>> = {
  'reebelo-us': usBlog,
  'reebelo-uk': ukBlog,
  'reebelo-au': auBlog,
  'reebelo-ca': caBlog,
  quista: sgBlog,
  'reebelo-nz': nzBlogs,
  'reebelo-dev': usBlog,
};

const blogs = BLOGS_BY_STORE[settings.store] ?? null;

export default blogs;
